import React from "react"
import { motion } from "framer-motion"
import { X, XCircle } from "lucide-react"

interface Props {
    isLoading: boolean
    onConfirm: () => void
    onClose: () => void
}

const RejectOrderModal: React.FC<Props> = ({ isLoading, onConfirm, onClose }) => (
    <div
        className="fixed inset-0 z-[10020] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4"
        onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
    >
        <motion.div
            initial={{ opacity: 0, scale: 0.93, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.2 }}
            className="bg-white rounded-2xl shadow-2xl w-full max-w-sm"
        >
            <div className="flex items-center justify-between p-5 border-b border-gray-100">
                <h3 className="font-semibold text-red-600">Reject this order?</h3>
                <button
                    onClick={onClose}
                    className="p-1.5 rounded-lg hover:bg-gray-100 transition-colors"
                    type="button"
                    aria-label="Close"
                >
                    <X size={16} />
                </button>
            </div>
            <div className="p-5 space-y-3">
                <p className="rounded-lg bg-red-50 px-3 py-2.5 text-sm text-red-700">
                    The customer is told the order was declined. You can't undo this.
                </p>
                <p className="text-sm text-gray-500">If the price is the only problem, send a counter offer instead.</p>
            </div>
            <div className="flex gap-3 px-5 pb-5">
                <button
                    type="button"
                    onClick={onClose}
                    className="flex-1 py-2.5 rounded-lg border border-gray-200 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
                >
                    Keep Order
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 rounded-lg bg-red-600 hover:bg-red-700 text-white text-sm font-semibold transition-colors disabled:opacity-50"
                >
                    <XCircle size={16} />
                    {isLoading ? "Rejecting..." : "Reject Order"}
                </button>
            </div>
        </motion.div>
    </div>
)

export default RejectOrderModal
